import type { ContactUsConfig } from './types'
import { commonTexts } from './common'

/**
 * NovelSprig 品牌 Contact Us 页面配置
 */
export const contactUsConfig: ContactUsConfig = {
  texts: commonTexts,
  colors: {
    bgPrimary: '#ffffff',
    bgTertiary: '#ECFDF5',
    textPrimary: '#1F2937',
    textTertiary: '#6B7280',
    textPlaceholder: '#c8c9cc',
    accentRed: '#FF3B30',
    primaryColor: '#10B981',
    whiteColor: '#FFFFFF',
  },
}
